<!-- 根据类型进行渲染 -->
<ng-container [ngSwitch]="component.widget">
  <ng-container *ngSwitchCase="'layout-form'">
    <ng-container *ngTemplateOutlet="formRender; context: { $implicit: component, parentComponent: parentComponent }"> </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'group'">
    <ng-container *ngTemplateOutlet="groupRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'title'">
    <ng-container *ngTemplateOutlet="titleRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="defaultRender; context: { $implicit: component, parentComponent: parentComponent }"></ng-container>
  </ng-container>
</ng-container>

<!-- 表单 -->
<ng-template #formRender let-subComponent let-parentComponent="parentComponent">
  <form #widgetFormRef="ngForm" nz-row nz-form style="height: 100%" [ngClass]="{ formBordered: subComponent.bordered }">
    <div
      dndDropZone
      [dndDisableIf]="disableDragDrop"
      [dndAllowExternal]="true"
      (dndDrop)="onDngDrop($event, subComponent)"
      [ngStyle]="{ 'min-height: 300px;': subComponent.children.length === 0 }"
      class="widget-form-list"
      style="width: 100%; text-align: left"
    >
      <div dndPlaceholderRef class="widget-form-item-placeholder"></div>

      <ng-container *ngFor="let childComponent of subComponent.children; let i = index">
        <div
          [dndDraggable]="childComponent"
          [dndDisableIf]="disableDragDrop"
          dndEffectAllowed="move"
          (dndMoved)="onDragged('move', subComponent, childComponent)"
          nz-col
          [nzMd]="childComponent.span || 12"
          [nzXs]="24"
          [nzOffset]="childComponent.offset || 0"
          class="widget-form-list-item"
          [attr.data-id]="childComponent.id"
          [attr.id]="'widget-' + childComponent.id"
          style="display: inline-block; width: 100%; float: left"
        >
          <div>
            <div
              d-widget-form-render
              [disableDragDrop]="disableDragDrop"
              [parentComponent]="subComponent"
              [component]="childComponent"
              [widgetIndex]="i"
              [selectComponent]="selectComponent"
              (selectComponentChange)="handleSelectComponent($event)"
              (cloneComponent)="handleComponentClone(i)"
              (deleteComponent)="handleComponentDelete(i)"
              (clearComponent)="handleComponentClear(i)"
            >
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</ng-template>
<!-- group -->
<ng-template #groupRender let-subComponent let-parentComponent="parentComponent">
  <!-- 列表 -->
  <nz-form-item
    class="widget-form-item"
    [ngClass]="{ active: selectComponent === subComponent, required: subComponent.required }"
    (click)="callSelectWidgetChange(subComponent, $event)"
  >
    <nz-form-label *ngIf="!subComponent.bordered" [hidden]="subComponent.hiddenLabel" [nzRequired]="subComponent.required" nzSpan="24">
      <div>{{ subComponent.label }}</div>
    </nz-form-label>
    <nz-form-control nzSpan="24">
      <!-- 渲染普通控件 -->
      <div
        dndDropZone
        [dndDisableIf]="disableDragDrop"
        [dndAllowExternal]="true"
        (dndDrop)="onDngDrop($event, subComponent)"
        [ngStyle]="{ 'min-height: 300px;': subComponent.children.length === 0 }"
        class="d-groups widget-form-container"
        style="width: 100%; text-align: left"
      >
        <!-- palceholder -->
        <div dndPlaceholderRef class="widget-form-item-placeholder"></div>

        <!-- 渲染子项 -->
        <ng-container *ngFor="let childComponent of subComponent.children; let i = index">
          <div
            [dndDraggable]="childComponent"
            [dndDisableIf]="disableDragDrop"
            dndEffectAllowed="move"
            (dndMoved)="onDragged('move', subComponent, childComponent)"
            nz-col
            [nzMd]="childComponent.span || 12"
            [nzXs]="24"
            [nzOffset]="childComponent.offset || 0"
            class="widget-form-list-item"
            [attr.data-id]="childComponent.id"
            [attr.id]="'widget-' + childComponent.id"
            style="display: inline-block; width: 100%; float: left"
          >
            <div>
              <div
                d-widget-form-render
                [disableDragDrop]="disableDragDrop"
                [parentComponent]="subComponent"
                [component]="childComponent"
                [widgetIndex]="i"
                [selectComponent]="selectComponent"
                (selectComponentChange)="handleSelectComponent($event)"
                (cloneComponent)="handleComponentClone(i)"
                (deleteComponent)="handleComponentDelete(i)"
                (clearComponent)="handleComponentClear(i)"
              >
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- 控件遮罩 -->
      <div class="widget-mask"></div>
    </nz-form-control>
    <!-- 功能按钮 -->
    <ng-container *ngIf="selectComponent === subComponent && !selectComponent.editLabel && !disableDragDrop">
      <button
        nz-button
        class="widget-action-clone"
        title="复制"
        nzType="primary"
        nzShape="circle"
        (click)="callCloneComponent(subComponent)"
        nzSize="small"
        >c
      </button>
      <button
        nz-button
        class="widget-action-delete"
        title="删除"
        nzDanger
        nzShape="circle"
        nzSize="small"
        (click)="callDeleteComponent(subComponent)"
        >d
      </button>
    </ng-container>
  </nz-form-item>
</ng-template>

<!-- title -->
<ng-template #titleRender let-subComponent let-parentComponent="parentComponent">
  <nz-form-item
    class="widget-form-item"
    [ngClass]="{ active: selectComponent === subComponent, required: subComponent.required }"
    (click)="callSelectWidgetChange(subComponent, $event)"
  >
    <nz-form-control>
      <!-- 渲染普通控件 -->
      <div d-widget-form-item [item]="subComponent"></div>
      <!-- 控件遮罩 -->
      <div class="widget-mask"></div>
    </nz-form-control>
    <!-- 功能按钮 -->
    <ng-container *ngIf="selectComponent === subComponent && !selectComponent.editLabel && !disableDragDrop">
      <button
        nz-button
        class="widget-action-clone"
        title="复制"
        nzType="primary"
        nzShape="circle"
        (click)="callCloneComponent(subComponent)"
        nzSize="small"
        >c
      </button>
      <button
        nz-button
        class="widget-action-delete"
        title="删除"
        nzDanger
        nzShape="circle"
        nzSize="small"
        (click)="callDeleteComponent(subComponent)"
        >d
      </button>
    </ng-container>
  </nz-form-item>
</ng-template>

<!-- 默认 -->
<ng-template #defaultRender let-subComponent let-parentComponent="parentComponent">
  <nz-form-item
    class="widget-form-item"
    [ngClass]="{
      active: selectComponent === subComponent,
      required: subComponent.required,
      bordered: parentComponent.bordered
    }"
    (click)="callSelectWidgetChange(subComponent, $event)"
  >
    <!-- 显示边框时，隐藏label， parentComponent.bordered -->
    <!-- 标题 -->
    <nz-form-label
      *ngIf="!parentComponent.bordered"
      [hidden]="subComponent.hiddenLabel"
      [style.width]="getLabelWidth(subComponent)"
      [nzRequired]="subComponent.required"
    >
      <div>{{ subComponent.label }}</div>
    </nz-form-label>
    <nz-form-control>
      <!-- 渲染普通控件 -->
      <div d-widget-form-item [item]="subComponent"></div>
      <!-- 控件遮罩 -->
      <div class="widget-mask"></div>
    </nz-form-control>
    <!-- 功能按钮 -->
    <ng-container *ngIf="selectComponent === subComponent && !selectComponent.editLabel && !disableDragDrop">
      <button
        nz-button
        class="widget-action-clone"
        title="复制"
        nzType="primary"
        nzShape="circle"
        (click)="callCloneComponent(subComponent)"
        nzSize="small"
        >c
      </button>
      <button
        nz-button
        class="widget-action-delete"
        title="删除"
        nzDanger
        nzShape="circle"
        nzSize="small"
        (click)="callDeleteComponent(subComponent)"
        >d
      </button>
    </ng-container>
  </nz-form-item>
</ng-template>
